import { Carousel } from "primereact/carousel";
import { Skeleton } from "primereact/skeleton";
import { TabPanel, TabView } from "primereact/tabview";
import { useMemo } from "react";
import { PathCard } from "sj-ui-toolkit/src/atlas/components/ContentCard/PathCard/PathCard";
import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils";

import carouselStyles from "../CarouselOverrides.module.scss";

export const MyPaths = ({
  paths = [],
  isLoading = false,
  hasOutstandingStrictAssignment = false,
}) => {
  const mappedEnrollments = useMemo(() => {
    return paths?.map(path => ({
      ...path,
      id: path.roleId,
      disabled: hasOutstandingStrictAssignment,
    }));
  }, [paths, hasOutstandingStrictAssignment]);

  const mappedPaths = useMemo(() => {
    return mappedEnrollments?.filter(e => e.enrollmentType === "path") || [];
  }, [mappedEnrollments]);

  const mappedQuests = useMemo(() => {
    return mappedEnrollments?.filter(e => e.enrollmentType === "quest") || [];
  }, [mappedEnrollments]);

  if (isLoading) {
    return (
      <div className={carouselStyles.carouselContainer}>
        <TabView
          className={`${carouselStyles.carouselSection}`}
          pt={{
            navContainer: { className: C("sticky top-0 z-2", T.bgElevation0) },
            nav: { className: `atlas-h5 ${carouselStyles.sectionHeader}` },
            panelContainer: { className: C(T.bgElevation0, "p-0") },
          }}
        >
          <TabPanel header="My Paths">
            <Skeleton width="100%" height="500px" borderRadius="8px" />
          </TabPanel>
        </TabView>
      </div>
    );
  }

  if (!paths?.length) {
    return null;
  }

  return (
    <div className={carouselStyles.carouselContainer}>
      <TabView
        className={carouselStyles.carouselSection}
        pt={{
          navContainer: { className: C("sticky top-0 z-2", T.bgElevation0) },
          nav: { className: C("atlas-h5", carouselStyles.sectionHeader) },
          panelContainer: { className: C("p-0", T.bgElevation0) },
        }}
      >
        {mappedPaths.length > 0 && (
          <TabPanel header="My Paths">
            <Carousel
              className={carouselStyles.customCarousel}
              value={mappedPaths}
              numVisible={1}
              numScroll={1}
              showNavigators={true}
              itemTemplate={(path, index) => <PathCard key={index} {...path} cardSize="large" />}
            />
          </TabPanel>
        )}
        {mappedQuests.length > 0 && (
          <TabPanel header="My Quests">
            <Carousel
              className={carouselStyles.customCarousel}
              value={mappedQuests}
              numVisible={1}
              numScroll={1}
              showNavigators={true}
              itemTemplate={(path, index) => (
                <PathCard key={index} {...path} cardSize="large" pathType="Quest" />
              )}
            />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
};
